import IconPicker from './icon-picker.element.js';

export default IconPicker;

IconPicker.define('wje-icon-picker', IconPicker);
